'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).factory('Status', ['$resource', '$stateParams', 'apiSettings', function ($resource, $stateParams, apiSettings) {
	return $resource(apiSettings.baseUri + 'v1/status/:id', { id: '@id' }, {
		'list': {
			method: 'GET',
			isArray: false,
			params: {
				page: 1,
				pageSize: apiSettings.defaultPageSize,
				keyword: ''
			}
		},
		'listIds': {
			url: apiSettings.baseUri + 'v1/status/list/ids/:moduleId',
			method: 'GET',
			isArray: true
		}
	});
}]);